<template>
  <div id="app">
    <section class="main-title">
    <navigation />
    <div class="container" style="margin-top:5rem">
        <h1 class="display-4" v-html="$t('main-01')"></h1>
        <p class="lead" v-html="$t('main-02')"></p>
    </div>
    </section>
    <!-- This displays what the router selected -->
    <router-view></router-view>
    <smfFooter :company="$t('solostec')"></smfFooter>
  </div>
</template>

<style>

html,
body {
  height: 100%;
}

.main-title {
    background-image: url("assets/bg3.jpg");
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: 50% 0%;
    background-size: cover;
    height: 100%;
    min-height: 38rem;
    color:white;
    text-align: center;
}
</style>

<script>
import navigation from '@/components/navigation.vue'
import smfFooter from '@/components/smf-footer.vue'

export default {
  name: 'app',
  components: {
    navigation, smfFooter
  },
  mounted () {
    console.log('NODE_ENV: ' + process.env.NODE_ENV)
  }
}
</script>
